import React, { useEffect, useState } from 'react';
import { Chip, Paper, Stack, Typography } from '@mui/material';
import { adminApi } from '../../lib/api';

export default function AdminSubmissions({ token }) {
  const [submissions, setSubmissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    adminApi
      .listSubmissions(token)
      .then((data) => setSubmissions(data.submissions || []))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [token]);

  if (loading) return <Typography sx={{ color: 'text.secondary' }}>Loading…</Typography>;
  if (error) return <Typography color="error">{error}</Typography>;
  if (submissions.length === 0) {
    return (
      <Typography sx={{ color: 'text.secondary' }}>
        No enquiries yet. This list is the durable fallback destination for the contact form — set RESEND_API_KEY,
        CONTACT_EMAIL_TO and CONTACT_EMAIL_FROM to also receive enquiries by email.
      </Typography>
    );
  }

  return (
    <Stack spacing={1.5}>
      {submissions.map((s) => (
        <Paper key={s.id} variant="outlined" sx={{ p: 2 }}>
          <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.5, flexWrap: 'wrap' }}>
            <Typography fontWeight={700}>{s.name}</Typography>
            <Chip size="small" label={s.type} />
            <Typography variant="caption" sx={{ color: 'text.secondary' }}>
              {new Date(s.createdAt).toLocaleString()}
            </Typography>
          </Stack>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {s.organization} · {s.email} {s.phone ? `· ${s.phone}` : ''}
          </Typography>
          <Typography variant="body2" sx={{ mt: 1, whiteSpace: 'pre-wrap' }}>
            {s.message}
          </Typography>
        </Paper>
      ))}
    </Stack>
  );
}
